import axios from '../../../axios';
import IPrismAccessControl from '../types/IPrismAccessControl';

const url = '/api/prism';

export const getAllPrismAccessedUsers = () => axios.get(`${url}/access-control`);

export const saveAccessControl = (accessControl: IPrismAccessControl) =>
  axios.post(`${url}/access-control`, accessControl);

export const deleteAccessControl = (id: number) => axios.delete(`${url}/access-control/${id}`);
